import URLRenderer from '@/app/common/components/CellRenderers/URLRenderer';
import CancelModal from '@/app/common/components/CancelModal';
import { errorMessage, successMessage } from '@/utils/toast';
import { useContext, type ComponentType, type ReactElement, type ReactNode } from 'react';
import { RemoveAnalysisContext } from '@/context/Context';
import {
  useDeleteAnalysisMutation,
  usePauseAnalysisMutation
} from '@/app/PageSpeed/api/analysisApi';

const SimpleURLRenderer = URLRenderer as (props: {
  url?: string | boolean | null;
}) => ReactElement;

type CancelModalProps = {
  show: boolean;
  setShow: (show: boolean) => void;
  title: ReactNode;
  desc: ReactNode;
  submitFunc: () => void;
  submitTitle?: string;
  isSubmitting?: boolean;
  buttonSize?: string | number;
};

const TypedCancelModal = CancelModal as ComponentType<CancelModalProps>;

type Props = { children?: ReactNode };

const AnalysisModalProvider = ({ children }: Props) => {
  const { analysisId, analysisUrl, show, setShow, status } = useContext(
    RemoveAnalysisContext
  );
  const [deleteAnalysis] = useDeleteAnalysisMutation();
  const [pauseAnalysis] = usePauseAnalysisMutation();

  return (
    <>
      <TypedCancelModal
        submitTitle={`آره، ${status === 6 ? 'حذف' : 'لغو'} بشه`}
        desc={
          <div className="d-flex align-items-center gap-2">
            آیا از {status === 6 ? 'حذف' : 'لغو'} واکاوی{' '}
            <strong className="fw-black">
              <SimpleURLRenderer url={analysisUrl} />
            </strong>{' '}
            مطمئن هستی؟
          </div>
        }
        show={show}
        title={`${status === 6 ? 'حذف' : 'لغو'} اطلاعات واکاوی`}
        setShow={setShow}
        submitFunc={() => {
          status === 6
            ? deleteAnalysis(analysisId)
                .unwrap()
                .then(() => {
                  successMessage('اطلاعات با موفقیت حذف شد');
                })
                .catch(err => {
                  errorMessage('خطایی در حذف اطلاعات وجود داره');
                  console.error(err);
                })
            : pauseAnalysis(analysisId)
                .unwrap()
                .then(() => {
                  successMessage('واکاوی با موفقیت لغو شد');
                })
                .catch(err => {
                  errorMessage('خطایی در لغو اطلاعات وجود داره');
                  console.error(err);
                });
        }}
      />
      {children}
    </>
  );
};

export default AnalysisModalProvider;
